import React, {useState} from 'react';
import gql from "graphql-tag";
import MessageBox from "../../../components/MessageBox";
import Button from "../../../components/Buttons/Button";
import * as PropTypes from "prop-types";
import Icon from "../../../components/Icon";
import {useProjectCommands} from "../../../graphql/Project/hooks";
import {useNavigate, useParams} from "react-router-dom";
import {confirm, errorAlert} from "../../../utils/alert";
import {projectsPath} from "../routes";


function I(props) {
  return null;
}

I.propTypes = {name: PropTypes.string};
const ProjectDangerZone = ({deleting, handleDelete}) => {



  return(
    <div className={'grid grid-cols-12'}>
      <div className={'col-span-6'}>
        <h3 className="text-lg mb-4 font-semibold">Danger Zone</h3>
        <Button red icon={'trash-alt'} onClick={handleDelete} loading={deleting}> Delete Project</Button>
      </div>
      <div className={'col-span-5 pl-12 '}>
        <MessageBox danger>
          <h3 className="text-lg font-bold">Delete this project</h3>
          <p>
            Once you delete a project, there is no going back. Please be certain.
          </p>
        </MessageBox>
      </div>
    </div>
  )
};
export default ProjectDangerZone;